/**
 * Auth — public API.
 *
 * Usage:
 *   import { AuthCover } from "@/components/auth";
 */
export { AuthCover } from "@/components/auth/auth-cover";
